import { connect } from 'react-redux';

import FooterHotel from './component';

const mapStateToProps = ({ hotel: { hotel, hotelData } }) => ({
	lineLink: hotelData[hotel].socialLinks.line,
	tripadvisorLink: hotelData[hotel].socialLinks.tripAdvisor,
	fbLink: hotelData[hotel].socialLinks.fb,
	igLink: hotelData[hotel].socialLinks.ig,
	weiboLink: hotelData[hotel].socialLinks.weibo,
	youtubeLink: hotelData[hotel].socialLinks.youtube,
});

export default connect(mapStateToProps)(FooterHotel);



// WEBPACK FOOTER //
// ./src/components/molecules/SocialGroup/index.js